import { render, staticRenderFns } from "./LangaugeIcon.vue?vue&type=template&id=76daa1a4"
import script from "./LangaugeIcon.vue?vue&type=script&lang=ts"
export * from "./LangaugeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports